
// CRITICAL: Explicitly import React to ensure it's loaded first
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

// Verify before polyfill that React is loaded properly
console.log("React pre-verification in main.tsx:", {
  createContext: typeof React.createContext === 'function',
  createElement: typeof React.createElement === 'function',
  Fragment: typeof React.Fragment !== 'undefined'
});

// Now import polyfill
import "./utils/commonjsPolyfill";

console.log("Main initialization starting - checking React availability...");

// Basic check to ensure React is properly defined
if (typeof React.createContext !== 'function') {
  console.error("CRITICAL: React.createContext not defined after importing React!");
  // Alert the user with a clear error message
  const errorMessage = "Critical application error: Required React functionality is not available. Please refresh the page or contact support.";
  console.error(errorMessage);
  
  // Try to display an error message in the UI
  try {
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="padding: 20px; margin: 30px auto; max-width: 500px; text-align: center; font-family: system-ui, sans-serif;">
          <h2 style="color: #e53e3e;">Application Error</h2>
          <p>${errorMessage}</p>
          <button onclick="window.location.reload()" style="margin-top: 20px; padding: 8px 16px; background: #3182ce; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Refresh Page
          </button>
        </div>
      `;
    }
  } catch (e) {
    // Silent catch - we've already logged the main error
  }
}

// Make React explicitly available globally before any other imports
// Ensure we're using the actual React module, not just the placeholder
window.React = React;
window.ReactDOM = ReactDOM;

console.log("React explicitly set on window in main.tsx:", {
  createContext: typeof window.React.createContext === 'function',
  createElement: typeof window.React.createElement === 'function'
});

// Now continue with normal imports
import App from "./App";
import "./index.css";

// Double check that React is still defined properly after all imports
console.log("Main execution continuing with React available:", typeof window.React === 'object', "createContext:", typeof window.React.createContext === 'function');

// Run a global debugging check
import { debugRequireState, validateReact } from "./utils/commonjsPolyfill";
debugRequireState();

// Final React check
const reactValid = validateReact();
if (!reactValid) {
  console.error("CRITICAL: React validation failed before rendering!");
} else {
  // Render the application using the correct ReactDOM.createRoot API
  const rootElement = document.getElementById("root");
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    console.error("Root element not found!");
  }
}
